require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-denizen-magazine-featuring-grange-residence.json") })
        }
      }, "path---journal-denizen-magazine-featuring-grange-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-denizen-magazine-featuring-grange-residence!./.cache/json/journal-denizen-magazine-featuring-grange-residence.json
// module id = 474
// module chunks = 231608221292675